import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetPricesMutationVariables = Types.Exact<{
  input: Types.SetPricesInput;
}>;


export type SetPricesMutation = { readonly __typename?: 'Mutation', readonly priceListV2: { readonly __typename?: 'PriceListV2Mutations', readonly setPrices: { readonly __typename?: 'SetPricesResponse', readonly processed: boolean } } };


export const SetPricesDocument = gql`
    mutation setPrices($input: SetPricesInput!) {
  priceListV2 {
    setPrices(input: $input) {
      processed
    }
  }
}
    `;
export type SetPricesMutationFn = Apollo.MutationFunction<SetPricesMutation, SetPricesMutationVariables>;

/**
 * __useSetPricesMutation__
 *
 * To run a mutation, you first call `useSetPricesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPricesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPricesMutation, { data, loading, error }] = useSetPricesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetPricesMutation(baseOptions?: Apollo.MutationHookOptions<SetPricesMutation, SetPricesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPricesMutation, SetPricesMutationVariables>(SetPricesDocument, options);
      }
export type SetPricesMutationHookResult = ReturnType<typeof useSetPricesMutation>;
export type SetPricesMutationResult = Apollo.MutationResult<SetPricesMutation>;
export type SetPricesMutationOptions = Apollo.BaseMutationOptions<SetPricesMutation, SetPricesMutationVariables>;